module.exports = __webpack_public_path__ + "img/specialSeal.4482dcd3.jpg";